import { CrudPage } from '@restavo/crud';
import React from 'react';
import { employeeRulesPage } from 'src/features/employeeRules';

const EmployeeRules = React.memo(() => <CrudPage {...employeeRulesPage} />);

export default EmployeeRules;
